export const quantumPageJA = {
  "seo": {
    "title": "ソブリンLLM＆量子AI | pAIoneer Labs GmbH",
    "description": "ドイツ発の目標：Veridion（「AIがAIをさらに進化させる」）のもと、将来的に米中の大規模モデルと競合する独自のコンパクト言語モデルと量子トランスフォーマーを開発します。"
  },
  "hero": {
    "kicker": "Made in Germany · AIがAIを開発する",
    "title": "ソブリンLLM＆量子AI",
    "claim": "ドイツからの私たちの目標は、将来的に米国や中国の大規模モデルに対抗し得る独自の言語モデルと量子トランスフォーマーを開発することです。",
    "subtitle": "実際の企業プロジェクトにおいて、ドイツのAleph Alpha（Kolibriなど）、フランス勢（Mistral周辺）、EuroLLM、特にスイスのApertusといった従来の欧州アプローチが実務課題で検証されましたが、企業の要求を満たすモデルはありませんでした。そのため、[Veridion](veridion)（「AIがAIをさらに進化させる」）のもとで私たちのAIは次のステップへ進みます。フランスのモデルを大きく凌駕するドイツ製コンパクト言語モデルへの道筋を研究開発し、第2の柱として独自の量子トランスフォーマーを推進しています。",
    "cta": "面談を予約する"
  },
  "pillars": {
    "title": "私たちのAIが取り組む研究開発",
    "subtitle": "デジタル社員が新しいアーキテクチャを設計し、シミュレータで検証しながら段階的に構築する2つの研究領域。",
    "items": [
      {
        "title": "実務の現場で言語モデルに求められる力",
        "description": "実運用で重要なのは、多段階の論理的推論、長い業務フローにわたる確実なツール利用、高品質なソフトウェア開発、ミスのないオフィス業務処理です。あらゆる設計を最初からこの基準で評価します。"
      },
      {
        "title": "自社インフラで動かせるコンパクトモデル",
        "description": "巨大化し続けるデータセンターに頼るのではなく、企業が将来的に自社のハードウェア上で完全にローカル運用できるコンパクトなモデルに深い思考力を凝縮することが私たちの目標です。"
      },
      {
        "title": "量子トランスフォーマー＆量子AI",
        "description": "第2の重点領域では、トランスフォーマー構造とパラメータ化量子回路およびテンソルネットワークを融合し、古典ネットワークを超える新しいモデルクラスの開拓を研究しています。"
      },
      {
        "title": "自社製Quantum IDE＆実機量子プロセッサ",
        "description": "独自開発したQuantum IDE上で、AI社員が新しい量子回路を設計・シミュレーションし、古典ベースラインと比較検証したうえで実機量子ハードウェアで実行します。"
      }
    ]
  },
  "gate": {
    "title": "最新の研究知見から設計ブループリントへ",
    "subtitle": "すべての開発ステップは、検証済み文献、企業メモリ、測定可能な比較に基づいています。",
    "stages": [
      {
        "step": "Step 01",
        "title": "文献解析＆企業メモリへの蓄積",
        "description": "AI社員が言語モデルおよび量子アーキテクチャに関する最新の学術論文を継続的に解析し、検証された知見を社内の知識グラフに体系化して保存します。"
      },
      {
        "step": "Step 02",
        "title": "学習ロードマップ＆回路シミュレーション",
        "description": "製品開発部門と連携し、将来の言語モデルに向けた詳細な学習計画を策定しつつ、並行してQuantum IDE内で新しい量子回路を検証します。"
      },
      {
        "step": "Step 03",
        "title": "IDDプロセスによる科学的検証",
        "description": "人間の物理学者とAI研究者が[Intent-Driven Development](idd)（IDD）のHuman-in-the-Loopとして各仮説・測定・設計を監査し、次のステップを承認します。"
      }
    ]
  },
  "stack": {
    "title": "人間とAIが一体となった研究ユニット",
    "subtitle": "基礎研究、製品開発、科学的ガバナンスが定周期で噛み合いながら進みます。",
    "items": [
      {
        "title": "24時間稼働するデジタル研究者",
        "description": "専門のAI社員が文献調査、数理導出、回路設計、評価分析を昼夜を問わず遂行します。"
      },
      {
        "title": "Human-in-the-Loopとしての物理学者",
        "description": "人間の科学者が研究の方向性を定め、前提を検証し、承認や実機実行、論文発表を決定します。"
      },
      {
        "title": "製品開発部門との緊密な連携",
        "description": "製品開発チームと密に連携し、実証された研究成果を自社ツールや将来のエンタープライズ製品へ直接反映します。"
      },
      {
        "title": "情報源まで完全に追跡可能",
        "description": "すべてのアーキテクチャ判断、棄却された設計案、測定結果は永続的に記録され、人間とAIの双方がいつでも検証できます。"
      }
    ]
  },
  "cta": {
    "title": "研究に関する意見交換",
    "subtitle": "ソブリン言語モデルおよび量子トランスフォーマーに関する私たちの研究についてお話ししませんか？お気軽にご連絡ください。",
    "button": "メッセージを送る"
  }
};
